import { Component, OnInit } from '@angular/core';
import { BaseTabsContainer, TabsContainerService, UserService } from 'yt-ng-framework';
import { Company } from './company';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-company-tabs',
  templateUrl: './company-tabs.component.html',
  providers: [
    TabsContainerService
  ]
})
export class CompanyTabsComponent extends BaseTabsContainer<Company> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<Company>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) {
    super(tabsContainerService, activatedRoute, userService);
   }

  ngOnInit() {
    super.ngOnInit();
  }

}
